import api from 'api/api'
import { toast } from "react-toastify"

import { API_URL } from 'constants/index'

export const GET_VEHICLES_REQUIREMENTS = "[VEHICLE REQUIREMENTS] GET VEHICLE REQUIREMENTS"

export const LOADING_VEHICLES_REQUIREMENTS = "[VEHICLE REQUIREMENTS] LOADING VEHICLES REQUIREMENTS"

export const GET_REQUIREMENT = "[VEHICLE REQUIREMENTS] GET REQUIREMENT"

export const GET_REQUIREMENTS_PENDINGS_BY_VEHICLE = "[VEHICLE REQUIREMENTS] GET REQUIREMENTS PENDINGS BY VEHICLE"

export const CRUD_VEHICLE_REQUIREMENT = "[VEHICLE REQUIREMENTS] CRUD VEHICLE REQUIREMENT"

export function getVehiclesRequirements({ page = 1, search = '', pageSize = 10 }) {
  const request = api.get(
    `/requerimientos`, {
    params: {
      page,
      por_pagina: pageSize,
      busqueda: search
    }
  })
  return dispatch => {
    dispatch({ type: GET_VEHICLES_REQUIREMENTS, payload: { loading: true } })
    request.then(response => {
      dispatch({ type: GET_VEHICLES_REQUIREMENTS, payload: { loading: false, ...response.data } })
      return
    }).catch(error => {
      dispatch({ type: GET_VEHICLES_REQUIREMENTS, payload: { loading: false } })
      console.log(error)
    })
  }
}

export function getVehicleRequirement(requirementId) {
  const request = api.get(`/grequerimiento/${requirementId}`)
  return (dispatch) => {
    dispatch({ type: GET_REQUIREMENT, payload: { loading: true } })
    toast.info("Obteniendo requerimiento...", { toastId: "getVehicleRequirement", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: GET_REQUIREMENT, payload: { loading: false, data: response.data.detalles } })
        toast.dismiss("getVehicleRequirement")
      } else {
        dispatch({ type: GET_REQUIREMENT, payload: { loading: false, data: null } })
        toast.update("getVehicleRequirement", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: GET_REQUIREMENT, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_REQUIREMENT, payload: { loading: false, data: null } })
      toast.update("getVehicleRequirement", { autoClose: 4000, type: "error", render: "Error al obtener el requerimiento" })
      console.log(error)
    })
  }
}

export function saveVehicleRequirement(form) {
  const request = api.post(`/rrequerimiento`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: true } })
    toast.info("Guardando requerimiento...", { toastId: "saveVehicleRequirement", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: true } })
        toast.update("saveVehicleRequirement", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("saveVehicleRequirement", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      toast.update("saveVehicleRequirement", { autoClose: 4000, type: "error", render: "Error al guardar el requerimiento" })
      console.log(error)
    })
  }
}

export function updateVehicleRequirement(form) {
  const request = api.post(`/arequerimiento`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: true } })
    toast.info("Actualizando requerimiento...", { toastId: "updateVehicleRequirement", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: true } })
        toast.update("updateVehicleRequirement", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("updateVehicleRequirement", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      toast.update("updateVehicleRequirement", { autoClose: 4000, type: "error", render: "Error al actualizar el requerimiento" })
      console.log(error)
    })
  }
}

export function deleteVehicleRequirement(form) {
  const request = api.post(`/erequerimiento`, form)
  return (dispatch) => {
    dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: true } })
    toast.info("Eliminando requerimiento...", { toastId: "deleteVehicleRequirement", autoClose: false })
    request.then((response) => {
      if (parseInt(response.data.status) === 200) {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: true } })
        toast.update("deleteVehicleRequirement", { autoClose: 4000, type: "success", render: response.data.message })
      } else {
        toast.update("deleteVehicleRequirement", { autoClose: 4000, type: "error", render: response.data.message })
      }
      return setTimeout(() => {
        dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: CRUD_VEHICLE_REQUIREMENT, payload: { loading: false, crud: false } })
      toast.update("deleteVehicleRequirement", { autoClose: 4000, type: "error", render: "Error al eliminar el requerimiento" })
      console.log(error)
    })
  }
}

export function getRequerimentsPendingsByVehicle(vehicleId, showLoading = false) {
  const request = api.get(`/greqpendientesvehiculo/${vehicleId}`)
  return (dispatch) => {
    if (showLoading) {
      toast.info("Obteniendo requerimientos pendientes del vehiculo...", { toastId: "getRequerimentsPendingsByVehicle", autoClose: false })
    }
    dispatch({ type: GET_REQUIREMENTS_PENDINGS_BY_VEHICLE, payload: { loading: true } })
    request.then((response) => {
      toast.dismiss("getRequerimentsPendingsByVehicle")
      dispatch({ type: GET_REQUIREMENTS_PENDINGS_BY_VEHICLE, payload: { loading: false, data: response.data.detalles } })
      setTimeout(() => {
        dispatch({ type: GET_REQUIREMENTS_PENDINGS_BY_VEHICLE, payload: { loading: false, data: null } })
      }, 50)
    }).catch((error) => {
      dispatch({ type: GET_REQUIREMENTS_PENDINGS_BY_VEHICLE, payload: { loading: false, data: null } })
      toast.error("Error al obtener requerimientos pendientes del vehiculo")
      console.log(error)
    })
  }
}